export default __webpack_public_path__ + "static/media/logo.46dfb79c.png";